<template>
    <div class="container-fluid">
        <Breadcrumb title="Activity Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group" v-if="this.$store.getters.isAdmin">
                            <label>User</label>
                            <treeselect placeholder="All"
                                        v-model="filter.userId"
                                        :multiple="false"
                                        :options="userList"
                                        :load-options="loadUserList"
                                        :auto-load-root-options="true"
                            />
                        </div>
                        <div class="input-group form-group">
                            <label>Campaign type</label>
                            <treeselect v-model="filter.campaignType" placeholder="All"
                                        :multiple="false"
                                        :searchable="false"
                                        :options="campaignTypeList"/>
                        </div>
                        <div class="input-group form-group">
                            <label>Date Range</label>
                            <date-picker v-model="range" range style="width:100%;" :lang="datePickerConf"></date-picker>
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getActivityReport()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length <= 1">{{emptyMessage}}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('event_date')">
                                                    <span role='button'>Date</span>
                                                </th>
                                                <th @click="tableOrdering('delivered')">
                                                    <span role='button'>Delivered</span>
                                                </th>
                                                <th @click="tableOrdering('bounced')">
                                                    <span role='button'>Bounced</span>
                                                </th>
                                                <th @click="tableOrdering('views')">
                                                    <span role='button'>Views</span>
                                                </th>
                                                <th @click="tableOrdering('clicks')">
                                                    <span role='button'>Clicks</span>
                                                </th>
                                                <th @click="tableOrdering('conversions')">
                                                    <span role='button'>Conv</span>
                                                </th>
                                                <th @click="tableOrdering('unsubscribers')">
                                                    <span role='button'>Unsub</span>
                                                </th>
                                                <th @click="tableOrdering('profit')">
                                                    <span role='button'>Profit</span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(row, index) in report" :key="index">
                                                <td class="align-middle">{{row.event_date ? row.event_date : 'Total'}}</td>
                                                <td class="align-middle">{{row.delivered}}</td>
                                                <td class="align-middle">{{row.bounced}}</td>
                                                <td class="align-middle">{{row.views}}</td>
                                                <td class="align-middle">{{row.clicks}}</td>
                                                <td class="align-middle">{{row.conversions}}</td>
                                                <td class="align-middle">{{row.unsubscribers}}</td>
                                                <td class="align-middle">{{row.profit}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import ReportService from '../services/ReportService';
    import UserService from '../services/UserService';
    import {CampaignType} from '../constants';
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment';

    export default {
        name: 'ProfitReport',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
            DatePicker
        },
        data() {
            return {
                report: [],
                emptyMessage: 'Select dates and get a report.',
                userList: null,
                filter: {
                    userId: null,
                    fromDate: null,
                    toDate: null,
                    campaignType: null,
                    orderBy: 'event_date',
                    asc: true
                },
                campaignTypeList: CampaignType.select,
                loading: false,
                range: [moment().subtract(7, 'days').toDate(), moment().toDate()],
                datePickerConf: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
            }
        },
        mounted() {
        },
        methods: {
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getActivityReport: function () {
                this.filter.fromDate = moment(this.range[0]).format('YYYY-MM-DD');
                this.filter.toDate = moment(this.range[1]).format('YYYY-MM-DD');
                this.loading = true;
                ReportService.getActivityReport(JSON.stringify(this.filter)).then(response => {
                    if (response.status !== 200) {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                        });
                        this.loading = false;
                        return;
                    }
                    this.report = response.data.report;
                    this.emptyMessage = 'No data found.';
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
            tableOrdering(field) {
                if (this.filter.orderBy === field) {
                    this.filter.asc = !this.filter.asc;
                } else {
                    this.filter.orderBy = field;
                    this.filter.asc = false;
                }
                this.getActivityReport();
            },
            getCampaignType(type) {
                return CampaignType.value[type];
            }
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Arial, serif;
    }
</style>
